import React, { useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translator } from '../../../utils/Translator';
import axios from 'axios';
import querystring from 'querystring';
import AmountFilter from './AmountFilter';
import DisplayFilter from './DisplayFilter';
import ItemGroupFilter from './ItemGroupFilter';
import ProductGroupFilter from './ProductGroupFilter';
import ProductLineFilter from './ProductLineFilter';
import ProductTypeFilter from './ProductTypeFilter';
import ProductGroupFocusFilter from './ProductGroupFocusFilter';
import ProductLineFocusFilter from './ProductLineFocusFilter';
import ProductTypeFocusFilter from './ProductTypeFocusFilter';

const SalesHistoryFilter = ({customerCode}) => {
    const { translate } = useSelector(({i18n}) => i18n);
    const { langCustomerFocus } = useSelector(({i18nCustomerFocus}) => i18nCustomerFocus);

    return (
        <>
            <div className="row justify-content-end mb-2">
                <div className="col-sm-4 col-6">
                    { langCustomerFocus.display } : <DisplayFilter placeholder={langCustomerFocus.display} /> 
                </div>
                <div className="col-sm-4 col-6">
                    { langCustomerFocus.numberType } : <AmountFilter placeholder={langCustomerFocus.numberType} />
                </div>
            </div>
            <div className="row">
                <div className="col-4">
                    { langCustomerFocus.itemGroup } : <ItemGroupFilter placeholder={langCustomerFocus.itemGroup} />
                </div>
                <div className="col-4">
                    { langCustomerFocus.productGroup } : <ProductGroupFilter placeholder={langCustomerFocus.productGroup} />
                </div>
                <div className="col-4">
                    { langCustomerFocus.productLine } : <ProductLineFilter placeholder={langCustomerFocus.productLine} />
                </div>
            </div>
            <div className="row">
                <div className="col-4">
                { translator(translate.ISA_ProductType, "ประเภทสินค้า") } : <ProductTypeFilter placeholder={"ProductType"} />
                </div>
                <div className="col-4 mt-2">
                    <label> { translator(translate.ISA_FocusGroup, "Focus Group") } : </label>
                    <ProductGroupFocusFilter />
                </div>
                <div className="col-4 mt-2">
                    <label> { translator(translate.ISA_FocusLine, "Focus Line") } : </label>
                    <ProductLineFocusFilter />
                </div>
            </div>
            <div className="row">
                <div className="col-4 mt-2">
                    <label> { translator(translate.ISA_FocusType, "Focus Type") } : </label>
                    <ProductTypeFocusFilter />
                </div>
                <div className="col-4">
                    
                </div>
                <div className="col-4">
                    
                </div>
            </div>
        </>
    );
}

export default SalesHistoryFilter;